import React, { useState } from 'react'
import { colorBrandObject } from '../../../../../constants/brandings';
import { Divider, Tooltip, Typography } from '@mui/material';
import { iconDefaultColor } from '../../../../reusableComponents/constants';
import AccordionWrapper from '../../../../reusableComponents/AccordionWrapper/AccordionWrapper';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import SplitPaymentIcon from '../../../../../assets/svg/splitPayment/splitPaymentIcon.svg'
import { formatAmount } from '../../../utils/utils';

function SplitPaymentDetails({ details }) {
    const [isOpen, setIsOpen] = useState(false)
    const splitSettleInfo = details?.authorisation?.splitSettlements.filter(el => el?.subMerchantId?.toLowerCase() !== "aggregator")
    let AggregatorInfo = details?.authorisation?.splitSettlements.filter(el => el?.subMerchantId?.toLowerCase() == "aggregator")
    AggregatorInfo = AggregatorInfo?.length ? AggregatorInfo[0] : {}
    return (
        <div style={{ display: "flex", paddingTop: "24px" }}>
            <div className="card-logo">
                <div style={{ stroke: iconDefaultColor }}>
                    <SplitPaymentIcon style={{ color: "#403E9F", width: "14px" }} />
                </div>
            </div>
            <div className="card-payment-info">
                <div className="card-details">
                    <Typography className="bodyB1MediumColored">
                        Split Settlement
                    </Typography>
                    <div className="order-category-root pb-0">
                        <div className="order-category" >
                            <Typography className="labelSemiBoldColored">Settlement Parties</Typography>
                        </div>
                        <div className="order-category">
                            <Typography className="labelSemiBoldColored">Amount</Typography>
                        </div>
                        {/* <div className="order-category">
                            <Typography className="labelSemiBoldColored"> Commission</Typography>
                        </div > */}
                    </div>
                    <AccordionWrapper isOpen={isOpen} initialHeight={180}>
                        <div className="order-category-root p-0 pb-1">
                            {AggregatorInfo?.money && <>
                                <div className="order-category py-2">
                                    <Tooltip title={"Commission"} placement="right-start" arrow followCursor>
                                        <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>Commission</Typography>
                                    </Tooltip>
                                </div>
                                <div className="order-category py-2">
                                    <Tooltip title={AggregatorInfo.partnerAmount} placement="right-start" arrow followCursor>
                                        <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}> {AggregatorInfo?.money?.currencyCode} {formatAmount({ amount: AggregatorInfo?.money?.amount?.toFixed(2) })}</Typography>
                                    </Tooltip>
                                </div>
                                <div className="order-category py-2"> </div>
                            </>}
                            {splitSettleInfo?.length > 0 && splitSettleInfo.map(el => {
                                return <>
                                    <div className="order-category py-2">
                                        <Tooltip title={el.partner} placement="right-start" arrow followCursor>
                                            <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>{el.subMerchantName}</Typography>
                                        </Tooltip>
                                    </div>
                                    <div className="order-category py-2">
                                        <Tooltip title={el.partnerAmount} placement="right-start" arrow followCursor>
                                            <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}> {el?.money?.currencyCode} {formatAmount({ amount: el?.money?.amount?.toFixed(2) })}</Typography>
                                        </Tooltip>
                                    </div>
                                    <div className="order-category py-2"> </div>
                                </>

                            })}
                        </div>
                    </AccordionWrapper>
                    {details?.authorisation?.splitSettlements?.length > 5 && <Typography className="bodyB2SemiBoldColored" style={{ color: "#403E9F", cursor: "pointer" }} onClick={() => setIsOpen(state => !state)} >
                        {isOpen ? <>View Less   <ExpandLessRoundedIcon /></> : <>View More Partners  <ExpandMoreRoundedIcon /></>}
                    </Typography>}

                </div>
                <div style={{ paddingRight: "36px", paddingTop: "24px" }}>
                    <Divider />
                </div>
            </div>

        </div >
    )
}

export default SplitPaymentDetails